import useDealerProvincePricing from '../../../utils/hooks/useDealerProvincePricing';
import { primaryCalculatorId, selectFinancialCalculator, selectPaymentOptions as selectPaymentOptionsFromCalculator, selectPrimaryCalculatorLoyaltyOfferKey, } from '../../../core/reducers/financialCalculators';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
import { useAppSelector } from '../../../core/utils';
import { useFetchPayment } from '../../../core/apiHooks/useFetchPayment';
const useFetchCurrentVehiclePaymentByDealerProvince = (calculatorId = primaryCalculatorId, shouldFetchPayment = true) => {
    const calculator = useAppSelector(state => selectFinancialCalculator(state, calculatorId));
    const { dealerProvinceCode } = useDealerProvincePricing();
    // prevent sending request before dealer and calculator are available
    const shouldFetch = !!(dealerProvinceCode && calculator) && shouldFetchPayment;
    const { trimKey, transmissionKey, exteriorColorKey, interiorColorKey, accessoryKeys, protectionKeys, protectionAddOnKeys, modelKey, modelYear, } = useAppSelector(selectCurrentVehicle);
    const paymentOptions = useAppSelector(state => selectPaymentOptionsFromCalculator(state, calculatorId));
    const isPrimaryCalculator = calculatorId === primaryCalculatorId;
    const primaryCalculatorLoyaltyOfferKey = useAppSelector(selectPrimaryCalculatorLoyaltyOfferKey);
    paymentOptions.loyaltyOfferKey =
        (isPrimaryCalculator && primaryCalculatorLoyaltyOfferKey) || paymentOptions.loyaltyOfferKey;
    return useFetchPayment({
        trimKey,
        modelKey,
        modelYear,
        transmissionKey,
        exteriorColorKey,
        interiorColorKey,
        accessories: Array.isArray(accessoryKeys) ? accessoryKeys : [],
        protections: Array.isArray(protectionKeys) ? protectionKeys : [],
        protectionAddOns: Array.isArray(protectionAddOnKeys) ? protectionAddOnKeys : [],
    }, paymentOptions, '', shouldFetch, dealerProvinceCode);
};
export default useFetchCurrentVehiclePaymentByDealerProvince;
